import { header } from './modules/header';
import { animation } from './modules/animation';


import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

window.addEventListener("load", () => {
	header();
	animation();

	// 右クリック禁止
	document.addEventListener('contextmenu', (e) => {
		e.preventDefault();
	});

	// 画像ドラッグ禁止
	document.addEventListener('dragstart', (e) => {
		if (e.target instanceof HTMLImageElement) {
		e.preventDefault();
		}
	});
});